import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend);

interface InvoiceAmountChartProps {
  data: {
    collectedAmount: number;
    receivedAmount: number;
    pendingAmount: number;
  };
}

export const InvoiceAmountChart: React.FC<InvoiceAmountChartProps> = ({ data }) => {
  const { t } = useTranslation();

  const chartData = {
    labels: [
      t('status.collected'),
      t('status.received'),
      t('status.pending'),
    ],
    datasets: [
      {
        label: t('forms.amount'),
        data: [data.collectedAmount, data.receivedAmount, data.pendingAmount],
        backgroundColor: [
          '#10b981',
          '#3b82f6',
          '#f59e0b',
        ],
        borderColor: [
          '#059669',
          '#1d4ed8',
          '#d97706',
        ],
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: 'bottom' as const,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return context.label + ': ' + context.parsed.toFixed(2);
          }
        }
      }
    },
  };

  return (
    <div className="chart-container">
      <h3>{t('dashboard:invoiceAmount')}</h3>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

